var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';







const getColor = (color) => {
  switch (color) {
    case 'gray':
      return 'bg-gray-500';
    case 'primary':
      return 'bg-primary-500';
    case 'success':
      return 'bg-success-500';
    case 'error':
      return 'bg-error-500';
    case 'warning':
      return 'bg-warning-500';
    default:
      return 'bg-gray-500';
  }
};

export const ProgressBar = ({ progress, color = 'gray', className = '' }) => /*#__PURE__*/
_jsx("div", { className: `w-full bg-gray-200 rounded-full h-2.5 ${className}` }, void 0, /*#__PURE__*/
_jsx("div", { className: `h-2.5 rounded-full ${getColor(color)}`, style: { width: `${progress}%` } })
);